import styled from "styled-components";

import bbqTitleSrc from "../../images/not-available-bbq.png";

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  background-color: #000;

  @media (max-width: 1023px) {
    padding: 72px 0;
  }

  @media (min-width: 1024px) {
    padding: 100px 0;
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-image: url(${bbqTitleSrc});
  background-repeat: no-repeat;
  background-position: left center;
  transform: rotate(-1deg);

  @media (max-width: 1023px) {
    height: 150px;
    padding-left: 50px;
    background-size: 79px 150px;
  }

  @media (min-width: 1024px) {
    height: 230px;
    padding-left: 65px;
    background-size: 121px 230px;
  }
`;

export const Title = styled.div`
  position: relative;
  color: #fff;
  font-family: "YWFT Ultramagnetic";
  text-align: center;
  text-transform: uppercase;

  @media (max-width: 1023px) {
    font-size: 38px;
  }

  @media (min-width: 1024px) {
    font-size: 70px;
  }

  &::before,
  &::after {
    content: "";
    position: absolute;
    background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 19 19' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill='%23bb8b2b' d='M 11.086 13.344 L 17.628 16.034 L 13.918 10.011 L 18.5 4.621 L 11.624 6.289 L 7.914 0.267 L 7.375 7.32 L 0.5 8.988 L 7.043 11.68 L 6.505 18.733 L 11.086 13.344 Z'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-size: cover;

    @media (max-width: 1023px) {
      top: 10px;
      width: 16px;
      height: 16px;
    }

    @media (min-width: 1024px) {
      top: 25px;
      width: 20px;
      height: 20px;
    }
  }

  &::before {
    @media (max-width: 1023px) {
      left: -25px;
    }

    @media (min-width: 1024px) {
      left: -40px;
    }
  }

  &::after {
    @media (max-width: 1023px) {
      right: -25px;
    }

    @media (min-width: 1024px) {
      right: -40px;
    }
  }
`;

export const Subtitle = styled.div`
  color: #c49f3f;
  font-family: "Rockwell";
  text-align: center;
  text-transform: uppercase;

  @media (max-width: 1023px) {
    margin-top: 5px;
    font-size: 18px;
  }

  @media (min-width: 1024px) {
    font-size: 26px;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  @media (max-width: 1023px) {
    margin-top: 48px;
    padding: 0 25px;
  }

  @media (min-width: 1024px) {
    max-width: 1550px;
    margin-top: 85px;
    padding: 0 60px;
  }
`;

export const CardsContainer = styled.div`
  width: 100%;

  @media (min-width: 1024px) {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    align-items: center;
  }
`;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  cursor: pointer;

  @media (max-width: 1023px) {
    justify-content: center;
    height: 210px;

    & + & {
      margin-top: 16px;
    }
  }

  @media (min-width: 1024px) {
    justify-content: flex-end;
    height: 650px;
    padding: 35px;
  }
`;

export const CardTitle = styled.div`
  color: #fff;
  font-family: "YWFT Ultramagnetic";
  text-align: center;
  text-transform: uppercase;

  @media (max-width: 1023px) {
    margin: 14px 0;
    font-size: 24px;
    line-height: 1.25;
  }

  @media (min-width: 1024px) {
    margin-bottom: 22px;
    font-size: 28px;
    line-height: 1.21;
  }
`;

export const Action = styled.button`
  display: flex;
  align-items: center;
  width: 116px;
  height: 24px;
  padding: 3px 0 0;
  color: #c49f3f;
  font-family: "Rockwell";
  text-transform: uppercase;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12'%3E%3Cpath fill='%23c49f3f' d='M7.196 5.996 3.208 2.011a.75.75 0 0 1 0-1.064.76.76 0 0 1 1.067 0l4.519 4.516a.752.752 0 0 1 .022 1.039l-4.538 4.547a.753.753 0 1 1-1.067-1.064l3.985-3.989Z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position-y: center;
  background-position-x: right;
  background-size: 12px;
  font-size: 14px;
  letter-spacing: 1.4px;
  transition: all 300ms ease;
  cursor: pointer;

  &:hover {
    background-position-x: 100%;
  }
`;
